import { render } from "./MethodologyEditing.vue?vue&type=template&id=6607507a&ts=true"
import script from "./MethodologyEditing.vue?vue&type=script&lang=ts"
export * from "./MethodologyEditing.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__